import React from 'react';
import { TopNavigation } from './TopNavigation';

interface ModernLayoutProps {
  children: React.ReactNode;
}

/**
 * Modern Layout Component
 * 
 * Ultra-modern layout for the Agentic AI platform with top navigation
 * 
 * @param {ModernLayoutProps} props - Component props
 * @returns {JSX.Element} Modern layout component
 */
export const ModernLayout: React.FC<ModernLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-agentic-white-off via-agentic-primary-blue/5 to-agentic-accent-purple/10">
      {/* Top Navigation */}
      <TopNavigation />
      
      {/* Main Content */}
      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};
